import { DaperClient, DaperFinanceReferenceCriteria } from "@data/daper-client";

import { wrapResponse } from "./wrapResponse";

async function getSecuritiesTopMovingHandler(req, res) {
  // eslint-disable-next-line no-param-reassign
  res = wrapResponse(res);

  const params = req.query as {
    index: string;
    criteria: DaperFinanceReferenceCriteria;
  };

  const daperClient = DaperClient.init({
    host: process.env.DAPER_URL,
    username: process.env.DAPER_MARKETS_USERNAME,
    password: process.env.DAPER_MARKETS_PASSWORD,
  });

  const daperResponse = await daperClient.getFinanceMoversSecurities(params);

  return res.status(200).json(daperResponse);
}

export default getSecuritiesTopMovingHandler;
